import {Stack} from "@mui/material";
import React from "react";
import {useTranslation} from "react-i18next";
import SurveyMarkdownField from "../../shared/richText/SurveyMarkdownField";
import {
    InlineInput,
    InlineLabelledField,
    localizedValue,
    patchLocalized,
    QuestionEditorProps
} from "./questionEditor.types";

function LegalQuestionEditor(props: QuestionEditorProps) {
    const {t} = useTranslation();
    const {question, patch, language, variables, disabled} = props;

    return (
        <Stack gap={1.5}>
            {/* Guests read it as markdown, so it is written in the rich text field, not typed as raw markdown. */}
            <InlineLabelledField label={t('Terms text')}>
                <SurveyMarkdownField
                    variant={'description'}
                    value={question.termsText}
                    language={language}
                    onChange={(next) => patch({termsText: next})}
                    placeholder={''}
                    variables={variables}
                    disabled={disabled}
                />
            </InlineLabelledField>

            <InlineLabelledField label={t('Agreement label')}>
                <InlineInput
                    value={localizedValue(question.agreementLabel, language)}
                    onChange={(value) => patchLocalized(props, 'agreementLabel', value)}
                    disabled={disabled}
                />
            </InlineLabelledField>
        </Stack>
    );
}

export default LegalQuestionEditor;
